import _ from 'lodash';
export const makeHeaderRow = (strDt, endDt) => {
  const headers = ['total'];

  for (let i = parseInt(strDt); i <= parseInt(endDt); i++) {
    headers.push(i);
  }

  return headers;
};

const headquaterData = [
  {
    id: '1',
    name: '인프라영업본부',
  },

  {
    id: '2',
    name: 'NI영업본부',
  },
  {
    id: '3',
    name: 'SI영업본부',
  },
  {
    id: '4',
    name: '채널영업본부',
  },
  {
    id: 'total',
    name: '합계',
  },
];

export const teamData = [
  {
    id: '1',
    name: '인프라영업본부',
    rowSpan: 4,
    children: [
      { id: '1-1', name: '고객영업1팀' },
      { id: '1-2', name: '고객영업2팀' },
      { id: '1-3', name: '고객영업3팀' },
      { id: '1-4', name: '고객영업4팀' },
    ],
  },
  {
    id: '2',
    name: '채널영업본부',
    rowSpan: 1,
    children: [{ id: '2-1', name: '채널영업팀' }],
  },
  {
    id: '3',
    name: 'NI영업본부',
    rowSpan: 1,
    children: [{ id: '2-1', name: 'NI영업팀' }],
  },
  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
    children: [{ id: 'total', name: '합계' }],
  },
];

export const empData = [
  {
    id: '1',
    name: '인프라영업본부',
    rowSpan: 6,
    children: [
      {
        id: '1-1',
        name: '고객영업1팀',
        rowSpan: 3,
        children: [
          { id: '1-1-1', name: '직원22 상무' },
          { id: '1-1-2', name: '직원11 과장' },
          { id: '1-1-3', name: '직원18 차장' },
        ],
      },
      {
        id: '1-2',
        name: '고객영업2팀',
        rowSpan: 1,
        children: [{ id: '1-2-1', name: '직원29 이사' }],
      },
      {
        id: '1-3',
        name: '고객영업3팀',
        rowSpan: 1,
        children: [{ id: '1-3-1', name: '직원30 전무' }],
      },
      {
        id: '1-4',
        name: '고객영업4팀',
        rowSpan: 1,
        children: [{ id: '1-4-1', name: '직원14 부장' }],
      },
    ],
  },
  {
    id: '2',
    name: '채널영업본부',
    rowSpan: 3,
    children: [
      {
        id: '2-1',
        name: '채널영업팀',
        rowSpan: 3,
        children: [
          { id: '2-1-1', name: '직원34 상무' },
          { id: '2-1-2', name: '직원01 과장' },
          { id: '2-1-3', name: '직원02 차장' },
        ],
      },
    ],
  },
  {
    id: '3',
    name: 'NI영업본부',
    rowSpan: 3,
    children: [
      {
        id: '3-1',
        name: 'NI영업팀',
        rowSpan: 3,
        children: [
          { id: '3-1-1', name: '직원35 과장' },
          { id: '3-1-2', name: '직원25 과장' },
          { id: '3-1-3', name: '김도연 주임' },
        ],
      },
    ],
  },
  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
    children: [
      {
        id: 'total',
        name: '합계',
        rowSpan: 1,
        children: [{ id: 'total', name: '합계' }],
      },
    ],
  },
];

export const makeGoalStaticsHeadquartData = (headers) => {
  _.forEach(headquaterData, (arr) =>
    _.forEach(headers, (hd) => {
      arr[hd] = `${Math.floor(Math.random() * 1000000000)}`;
    }),
  );

  return Array.from(headquaterData);
};

export const makeGoalStaticsTeamData = (headers) => {
  _.forEach(teamData, (hq) =>
    _.forEach(hq.children, (team) => {
      _.forEach(headers, (hd) => {
        team[hd] = `${Math.floor(Math.random() * 1000000000)}`;
      });
    }),
  );

  return Array.from(teamData);
};

export const makeGoalStaticsEmpData = (headers) => {
  _.forEach(empData, (hq) =>
    _.forEach(hq.children, (dp) => {
      _.forEach(dp.children, (emp) => {
        _.forEach(headers, (hd) => {
          emp[hd] = `${Math.floor(Math.random() * 1000000000)}`;
        });
      });
    }),
  );

  return Array.from(empData);
};
